;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Collection 	= APP.module('Collection');
	var Model 		= APP.module('Model');

	Collection.Squads = Backbone.Collection.extend({
		model             : Model.Squad,
		url               : 'squads.json',
		image_url_prefix  : CONFIG.SQUADS_URL,
		image_url_identity: 'id',

		setNextMatch: function(round_id, rounds) {

			_.each(rounds.filter(function(round) { return round.get('id') >= round_id }), _.bind(function(round) {
				var matches = round.get('matches');
				_.each(matches, _.bind(function(match) {
					var squad;

					squad = this.get(match.home_squad_id);
					if (!squad.get('next_match')) {
						squad.set('next_match', match);
					}
					squad = this.get(match.away_squad_id);
					if (!squad.get('next_match')) {
						squad.set('next_match', match);
					}
				}, this));
			}, this));

			return this;
		},

		setImageUrl: function() {

			var prefix   = this.image_url_prefix,
				identity = this.image_url_identity;

			this.each(function(squad) {
				squad.set('image_url', prefix + squad.get(identity));
			});

			return this;
		},

		setImageUrlPrefix: function(value) {

			this.image_url_prefix = value;

			return this;
		},

		setImageUrlIdentity: function(value) {

			this.image_url_identity = value;

			return this;
		},

		toObjectByParam: function(param) {
			return _.indexBy(this.toJSON(), param || 'id');
		},

		getSquadsOptions() {
			return this.map(squad => {
				return {
					val: squad.get('id'),
					label: squad.get('name')
				}
			});
		}
	});

}(window, APP, Backbone, Marionette, $, _));